import { action, computed, observable, makeObservable } from 'mobx';

import { ComponentTierName } from '@/constants/enums';
import { TrendsMock } from '@/constants/TrendsMock';
import epaxios from '@/utils/epaxios';
import { checkTierPermission, waitFor } from '@/utils/util-functions';

import RootStore from './RootStore';

const LOADER_TIMEOUT = 0;

export default class TrendsStore {
  rootStore: typeof RootStore;
  @observable _flow = [];
  @observable _pressure = [];
  @observable _power = [];
  @observable _specificPower = [];
  @observable isLoading = false;

  constructor(rootStore) {
    makeObservable(this);
    this.rootStore = rootStore;
  }

  @action get = async ({ startDate, endDate }) => {
    if (!startDate || !endDate) return;
    const stationId = this.rootStore.stationStore?.currentStation.id;
    try {
      this.isLoading = true;
      await waitFor(() => this.rootStore.stationStore.isLoading === false);
      let trends;
      if (checkTierPermission(ComponentTierName.TrendsViewMockAsset, this.rootStore.stationStore)) {
        trends = TrendsMock;
      } else {
        trends = (await epaxios.get(`/station/${stationId}/trends?startDate=${startDate}&endDate=${endDate}`))?.data;
      }

      const { flowM3Min, pressureBar, powerKw, specificPower } = trends.data;

      setTimeout(() => {
        this._flow = flowM3Min;
        this._pressure = pressureBar;
        this._power = powerKw;
        this._specificPower = specificPower;
      }, LOADER_TIMEOUT);
    } catch (e) {
      this._flow = [];
      this._pressure = [];
      this._power = [];
      this._specificPower = [];
    } finally {
      setTimeout(() => {
        this.isLoading = false;
      }, LOADER_TIMEOUT);
    }
  };

  @computed get flow() {
    return this._flow.map(([date, value]) => [Date.parse(date), value]);
  }

  @computed get pressure() {
    return this._pressure.map(([date, value]) => [Date.parse(date), value]);
  }

  @computed get power() {
    return this._power.map(([date, value]) => [Date.parse(date), value]);
  }

  @computed get specificPower() {
    return this._specificPower.map(([date, value]) => [Date.parse(date), value]);
  }
}
